<app-navbar-style-two></app-navbar-style-two>

<div class="inner-banner">
    <div class="container-max-2">
        <div class="row inner-title text-center">
            <div class="col-lg-12 col-md-12">
                <h3>{{service?.title}}</h3>
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><i class='bx bx-chevron-right'></i></li>
                    <li>Services</li>
                    <li><i class='bx bx-chevron-right'></i></li>
                    <li>{{service?.title}}</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="inner-banner-shape">
        <div class="shape-one"><img src="assets/img/inner-banner/banner-shape1.png" alt="Images"></div>
        <div class="shape-two"><img src="assets/img/inner-banner/banner-shape2.png" alt="Images"></div>
        <div class="shape-three"><img src="assets/img/inner-banner/banner-shape3.png" alt="Images"></div>
        <div class="inner-banner-dots"><img src="assets/img/shape/dots-shape.png" alt="Images"></div>
    </div>
</div>

<div class="services-details-area pt-50 pb-70">
    <div class="container">
        <div class="row">
         
            <div class="col-lg-8 col-md-12">
                <div class="services-left">
                    <div class="services-content">
                        <img src="assets/img/service/{{service?.image}}" alt="{{service?.title}}">
                        <h2>{{service?.mainContent?.title}}</h2>
                        <p>{{service?.mainContent?.description}}</p>
                    </div>

                    <div class="row">
                         <h2 class="section-title text-start">{{service?.mainContent?.heading}}</h2>
                        <div class="col-lg-6 col-sm-6" *ngFor="let feature of service?.mainContent?.content">
                            <div class="services-content-card">
                                <h3>{{feature.title}}</h3>
                                <p>{{feature.description}}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Key Features section -->
                    <div class="row">
                        <h2 class="section-title text-start">{{service?.keyft?.heading}}</h2>
                        <div class="col-lg-12 col-sm-12" *ngFor="let feature of service?.keyft?.content">
                                <h3>{{feature.title}}</h3>
                                <ul>
                                    <li *ngFor="let desc of feature.descriptions" [innerHTML]="desc"></li>
                                </ul>
                        </div>
                    </div>

                    <div class="content-widget-area">
                        <div class="row">
                            <div class="col-lg-7 col-md-12">
                                <div class="content-widget-img">
                                    <img src="assets/img/service/{{service?.image2}}" alt="{{service?.title}}">
                                </div>
                            </div>

                            <div class="col-lg-5 col-md-12">
                                <div class="content-widget-text">
                                    <h2 class="section-title text-start">{{service?.subContent?.title}}</h2>
                                    <p>{{service?.subContent?.description}}</p>
                                    <ul>
                                        <li *ngFor="let highlight of service?.subContent?.highlight">
                                            <i class='bx bx-check'></i>
                                            <strong>{{highlight.topic}}:</strong> {{highlight.detail}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Dialer () -->
                     <!-- Technical Features -->
                     <div class="row mb-4"> 
                        <h2 class="section-title text-start">{{ service?.oversight?.title }}</h2>
                        <div class="col-lg-12 col-sm-12" *ngFor="let content of service?.oversight?.content">
                            <p style="margin-bottom: 0px;" [innerHTML]="content.description"></p>
                        </div>
                    </div>

                    <!-- Technical Features -->
                     <div class="row"> 
                        <h2 class="section-title text-start">{{service?.technicalFeatures?.heading}}</h2>
                        <div class="col-lg-12 col-sm-12"
                            *ngFor="let section of service?.technicalFeatures?.sections">
                            <h3>{{ section.title }}</h3>
                            <ul>
                            <li *ngFor="let point of section.points" [innerHTML]="point"></li>
                            </ul>
                        </div>
                    </div>

                    <!-- Why Choose Us -->
                    <div class="row">
                        <div class="col-lg-12 col-sm-12" *ngFor="let solution of service?.solContent?.solution">
                            <h2 class="section-title text-start">{{service?.solContent?.title}}</h2>
                                <ul>
                                   <li *ngFor="let point of solution.points" [innerHTML]="point"></li>
                                </ul>
                        </div>
                    </div>

                    <!-- Support & Training -->
                    <div class="row">
                        <div class="col-lg-12 col-sm-12" *ngFor="let content of service?.supportContent?.content">
                            <h2 class="section-title text-start">{{ service?.supportContent?.title }}</h2>
                            <ul>
                            <li *ngFor="let point of content.points" [innerHTML]="point"></li>
                            </ul>
                        </div>
                    </div>


                    <!-- Security & Compliance -->
                     <div class="row">
                        <div class="col-lg-12 col-sm-12" *ngFor="let content of service?.securityContent?.content">
                              <h2 class="section-title text-start">{{service?.securityContent?.title}}</h2>
                                <ul>
                                    <li *ngFor="let point of content.points" [innerHTML]="point"></li>
                                </ul>
                        </div>
                    </div>

                    <!-- note- -->
                     <div class="row">
                        <div class="col-lg-12 col-sm-12" *ngFor="let content of service?.objectContent?.content">
                              <h5>{{service?.objectContent?.heading}}</h5>
                              <p>{{service?.objectContent?.title}}</p>
                        </div>
                    </div>

                    <!-- note-->
                    <div class="row">
                        <div class="col-lg-6 col-sm-6" *ngFor="let content of service?.noteContent?.content">
                            <h5>{{service?.noteContent?.heading}}</h5>
                            <p>{{service?.noteContent?.description}}</p>
                        </div>
                    </div>

                    <p class="mt-4">{{service?.subContent?.othercontent}}</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-widget-right">
                    <div class="contact-widget">
                        <h2>Contact Info</h2>
                        <ul>
                            <li>
                                <i class="flaticon-telephone"></i>
                                <div class="content">
                                    <h3>Phone: </h3>
                                    <span><a href="tel:{{service?.contactInfo?.phone}}">{{service?.contactInfo?.phone}}</a></span>
                                </div>
                            </li>
                            <li>
                                <i class="flaticon-email-1"></i>
                                <div class="content">
                                    <h3>Email:</h3>
                                    <span><a href="mailto:{{service?.contactInfo?.email}}">{{service?.contactInfo?.email}}</a></span>
                                </div>
                            </li>
                            <li>
                                <i class="flaticon-planet-earth"></i>
                                <div class="content">
                                    <h3>Location:</h3>
                                    <span>{{service?.contactInfo?.location}}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="services-widget-right">
                    <div class="contact-widget">
                        <h2>{{ service?.featuredList?.title }}</h2>
                        <ul>
                        <li *ngFor="let lists of service?.featuredList?.lists">
                            <div class="content-custom text-center">
                            <h3 [routerLink]="lists.route">{{ lists.name }}</h3>
                            </div>
                        </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>